import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Select } from "antd";
import { InputItem, TextAreaItem } from "../../components/forms/FormItems";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { createRecord, updateRecord } from "./roleDetailsSlice";
import { loadRoles } from "../roles/rolesSlice";
import { usePermissions } from "../../hooks";
import AddEntityForm from "../../components/templates/AddEntityForm";

const { Option } = Select;

const RoleForm = (props) => {
  const { onHide, mode, addText } = props;
  const [form] = Form.useForm();
  const [selectData, setSelectData] = useState([]);
  const dispatch = useDispatch();
  const activeRole = useSelector((state) => state.roleDetails.activeRole);
  const loading = useSelector((state) => state.pendingActions["role/create"]);
  const intl = useIntl();
  const allPermissions = usePermissions();

  useEffect(() => {
    if (allPermissions.length > 0) {
      setSelectData(allPermissions);
    }
  }, [allPermissions]);

  const onFinish = async (values) => {
    if (mode === "edit") {
      values["id"] = activeRole.id;
    }
    const action =
      mode === "new"
        ? await dispatch(createRecord(values))
        : await dispatch(updateRecord(values));
    if (!action.error) {
      dispatch(loadRoles());
      onHide();
      form.resetFields();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const items = [
    {
      name: "name",
      required: true,
      comp: (
        <InputItem
          required={true}
          name="name"
          category="roles"
          inputStyle={{ width: "200px" }}
        />
      ),
    },
    {
      name: "description",
      comp: <TextAreaItem name="description" category="roles" rows={2} />,
    },
    {
      name: "permissions",
      required: true,
      comp: (
        <Form.Item
          shouldUpdate
          label={intl.formatMessage({
            id: "app.forms.roles.permissions",
          })}
          name={"permissions"}
        >
          <Select mode="multiple" allowClear>
            {selectData.map((option) => (
              <Option key={option} value={option}>
                {intl.formatMessage({
                  id: "app.dataSelect.permissions." + option,
                })}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
  ];
  return (
    <AddEntityForm
      formLayout={{ labelCol: { span: 3 }, wrapperCol: { span: 21 } }}
      style={{ width: "900px", padding: "20px 40px" }}
      resource="organization.settings"
      action="editor"
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={onHide}
      saveLoading={loading}
      addText={addText}
      activeEntity={activeRole}
      mode={mode}
      twoColumns={false}
    />
  );
};

RoleForm.propTypes = {
  hide: PropTypes.func,
};

export default RoleForm;
